import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';

import { MobileSdkIssueQueryVariables } from '../MobileSdkIssue.generated';

const ISSUE_ID_PARAM_NAME = 'issueId';
const RUN_ID_PARAM_NAME = 'runId';

export const buildMobileSdkIssueVariables = (
	issueId: string,
	runId: string
): MobileSdkIssueQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileSdkIssueQueryVariables>();

	return variablesBuilder
		.addConditionParam(ISSUE_ID_PARAM_NAME, issueId)
		.addConditionParam(RUN_ID_PARAM_NAME, runId)
		.getVariables();
};
